import { render } from "./GuardLayout.vue?vue&type=template&id=8c7ecd46&ts=true"
import script from "./GuardLayout.vue?vue&type=script&lang=ts"
export * from "./GuardLayout.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__